var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageRightNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157,
    height: 174,
    viewBox: "0 0 157 174",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.348 7.46289L122.592 124.95",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.984 34.5469C156.984 34.5469 147.945 27.4219 142.89 35.8209C142.89 35.8209 143.65 24.4189 131.464 26.9169C131.464 26.9169 133.184 14.5279 119.519 15.7519C119.519 15.7519 125.003 3.55292 115.527 2.36792",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.654 61.395C151.654 61.395 146.15 50.713 137.945 57.534C137.945 57.534 130.892 38.602 110.97 49.209C110.97 49.209 116.447 23.153 92.988 23.125C92.988 23.125 102.3 0.79 89.074 0",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.18 81.3529C151.18 81.3529 137.746 74.6689 132.761 80.2949C132.761 80.2949 124.308 49.3769 98.2011 63.0979C98.2011 63.0979 103.413 39.1649 73.5901 28.5149C73.5901 28.5149 85.6461 8.19192 73.5901 2.36792",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7261 1.00195C15.7261 1.00195 54.8841 3.20596 56.8961 32.77C56.8961 32.77 79.8821 36.515 89.8101 72.226C89.8101 72.226 125.407 77.7299 126.676 107.022C126.676 107.022 157.844 113.291 152.148 163.001",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.62 119.632C123.62 119.632 147.827 134.204 151.308 172.996",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.47192C1 2.47192 35.006 10.2499 47.439 35.7829L149.348 7.46292L89.809 72.2259",
    stroke: "#5E5E5E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageRightNet);
export default __webpack_public_path__ + "static/media/pageRightNet.2a2d2f32af6dc0013f2c108919b3a278.svg";
export { ForwardRef as ReactComponent };